import React from 'react';

const MovePhone = () => (
  <svg
    width="43"
    height="36"
    viewBox="0 0 43 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter-move-phone)" fill="#fff">
      <path d="M19.833 7.544h1.73a.433.433 0 0 0 0-.867h-1.73a.433.433 0 0 0 0 .867zM23.293 7.544h-.432a.433.433 0 0 1 0-.867h.432a.433.433 0 0 1 0 .867z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8 26.233a1.734 1.734 0 0 0 0 3.467 1.734 1.734 0 0 0 0-3.467zm0 2.6a.867.867 0 0 1 0-1.733.867.867 0 0 1 0 1.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.28 7.093A2.092 2.092 0 0 0 27.19 5H16.3c-1.155 0-2.09.937-2.09 2.093v9.174H6.476l4.453-4.46a.433.433 0 0 0-.612-.614l-5.19 5.2a.437.437 0 0 0 0 .614l5.19 5.2a.433.433 0 0 0 .612-.613l-4.453-4.46h7.734v11.773c0 1.156.935 2.093 2.09 2.093h10.89c1.154 0 2.09-.937 2.09-2.093V17.133h7.244l-4.453 4.46a.433.433 0 0 0 .612.613l5.19-5.2a.434.434 0 0 0 0-.613l-5.19-5.2a.433.433 0 0 0-.612.613l4.453 4.46h-7.245V7.094zM16.3 6.047h10.89c.577 0 1.045.468 1.045 1.046v1.054h-12.98V7.093c0-.578.467-1.046 1.044-1.046zM28.234 24.92v-7.788H15.254v7.788h12.98zm-12.98 1.047v2.939c0 .578.467 1.046 1.044 1.046h10.89c.578 0 1.046-.468 1.046-1.046v-2.94h-12.98zm0-9.701V9.194h12.98v7.073H15.254z"
      />
    </g>
    <defs>
      <filter
        id="filter-move-phone"
        x="0"
        y="0"
        width="43"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="MovePhoneBackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
        <feBlend
          in2="MovePhoneBackgroundImageFix"
          result="effect1_dropShadow-move-phone"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow-move-phone"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MovePhone;
